import React from "react";
import { useDash } from "@/pages/dashboard/DashboardLayout";

export default function VenueTabs({ testidPrefix = "venue-tab" }) {
  const { venues, selectedVenue, setSelectedVenue } = useDash();
  const activeId = selectedVenue?.venue_id || venues[0]?.venue_id;

  return (
    <div className="flex flex-wrap gap-2" data-testid="venue-tabs">
      {venues.map((v) => {
        const active = v.venue_id === activeId;
        return (
          <button
            key={v.venue_id}
            onClick={() => setSelectedVenue(v)}
            data-testid={`${testidPrefix}-${v.name.toLowerCase()}`}
            className={`group flex items-center gap-2.5 rounded-md border px-4 py-2.5 text-sm font-semibold transition-all duration-150 ${
              active ? "border-transparent text-white shadow-pulse-md" : "border-slate-200 bg-white/60 text-slate hover:bg-white"
            }`}
            style={active ? { background: v.color } : {}}
          >
            <span className="h-2.5 w-2.5 rounded-full" style={{ background: active ? "#ffffff" : v.color }} />
            <span>{v.name}</span>
            {v.booking_count > 0 && (
              <span className={`grid h-5 min-w-5 place-items-center rounded-full px-1.5 text-[11px] font-semibold ${active ? "bg-white/25 text-white" : "text-white"}`}
                    style={active ? {} : { background: v.color }}>
                {v.booking_count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
